import { render } from "./News.vue?vue&type=template&id=64b82e5a&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=64b82e5a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b82e5a"]])

export default __exports__